













































































































import { Component, Prop, Vue } from "vue-property-decorator";
import ModalHeader from "@/components/ModalHeader.vue";
import { FormQuestionType } from "@/store/modules/enums";
import SingleChoiceAnswer from "./SingleChoiceAnswer.vue";
import MultipleChoiceAnswer from "./MultipleChoiceAnswer.vue";
import TextAnswer from "./TextAnswer.vue";
import EditorAnswer from "./EditorAnswer.vue";
import DateAnswer from "./DateAnswer.vue";
import TimeAnswer from "./TimeAnswer.vue";
import DateTimeAnswer from "./DateTimeAnswer.vue";
import { Form, FormQuestion } from "@/store/modules/types";
@Component({
  components: {
    ModalHeader,
    SingleChoiceAnswer,
    MultipleChoiceAnswer,
    TextAnswer,
    EditorAnswer,
    DateAnswer,
    TimeAnswer,
    DateTimeAnswer,
  },
})
export default class FormWizard extends Vue {
  @Prop() readonly form!: Form;
  @Prop(Array) readonly questions!: Array<FormQuestion>;
  prevIndex = 0;
  currIndex = 0;
  get question(): FormQuestion {
    return this.questions[this.currIndex];
  }
  answer(questionId: number, value: string, jumpToKey: string, updateGap,updateAppt) {
    const { answer } = this.question;
    answer.value = value;
    answer.jumpToKey = jumpToKey;
    answer.updateGap = updateGap;
    answer.updateAppt = updateAppt;
  }
  next() {
    const { answer } = this.question;
    if (this.question.isOptional || answer.value) {
      this.prevIndex = this.currIndex;
      if (answer.jumpToKey) {
        this.currIndex = this.questions.findIndex(
          (q) => q.key === answer.jumpToKey
        );
      } else {
        this.currIndex += 1;
      }
    }
  }
  gotoLastAnswer() {
    const id = this.answers[this.answers.length - 1].questionId;
    this.currIndex = this.questions.findIndex((q) => q.id === id);
  }
  back() {
    this.currIndex = this.prevIndex;
  }
  async save() {
    if (this.answers.length) {
      this.$emit("save-answers", this.answers);
      this.close();
    }
  }
  get answers() {
    return this.questions
      .filter((q) => q.answer.value)
      .map((q) => {
        return {
          questionId: q.id,
          answer: q.answer.value,
          updateGap: q.answer.updateGap,
          updateAppt: q.answer.updateAppt,
        };
      });
  }
  close() {
    this.$modal.hide("form-wizard");
  }
}
